import api from '../../../../utils/api';

export interface Institution {
    id: string,
    name: string,
    logoUrl: string,
}

const findListOfBanks = async (countryCode: string): Promise<Institution[]> => {
    return await api.getWithoutAuth(`api/screening/income-verification/list-banks`, { countryCode });
}

export default findListOfBanks;
